import React from 'react';
import { motion } from 'framer-motion';

class MotionFluffy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      children: props.children,
      class: 'p-dec--'+props.slug,
      state: props.state
    }
  }

  render() {
    return(
      <motion.div
        animate={{
          y: [0, 20, 0]
        }}
        transition={{
          duration: 5,
          ease: "easeInOut",
          repeat: Infinity,
          repeatDelay: 0
        }}
        className={this.state.class} data-state={this.state.state}
      >
        {this.state.children}
      </motion.div>
    )
  }
}

export default MotionFluffy;
